import { defineComponent as _defineComponent } from 'vue'
import { Ref, computed, onMounted, ref } from 'vue';
import { confirmEmail } from '@/api/user';
import { AxiosError } from 'axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailConfirmation',
  setup(__props) {

const username: Ref<string | null> = ref(null);
const token: Ref<string | null> = ref(null);
const errorMessage: Ref<string | null> = ref(null);

const emailConfirmed = ref(false);
const confirmedEmail: Ref<string | null> = ref(null);
const confirmedUsername: Ref<string | null> = ref(null);

const customilyImg = computed(() => {
    return require('@/angular-app/images/signInLogo.png');
});

onMounted(async () => {
    const url = new URL(location.href);
    username.value = url.searchParams.get('user');
    token.value = url.searchParams.get('token');

    if (!username.value || !token.value) return;
    try {
        const response = await confirmEmail(username.value, token.value);
        confirmedEmail.value = response.Email;
        confirmedUsername.value = response.Username;
        emailConfirmed.value = true;
    } catch (error) {
        const axiosError = error as AxiosError;
        if (axiosError.response?.status === 400) {
            if (axiosError.response.data.Message) {
                errorMessage.value = axiosError.response.data.Message;
            }
        } else {
            errorMessage.value = 'Fatal error';
            window.rumReportError(axiosError);
        }
    }
});

return { __sfc: true,username, token, errorMessage, emailConfirmed, confirmedEmail, confirmedUsername, customilyImg }
}

})